<template>
  <div class="knowledgelib-detail" v-if="ready" ref="watermarkArea">
    <template v-if="article">
      <div class="knowledgelib-detail-wrap crm-scroll">
        <div class="top-area" v-if="!noheader">
          <div class="category-list-wrap" ref="categoryListWrap">
            <ul class="category-list">
              <li
                v-for="category of article.categoryList"
                class="category-item"
                @click="onCategoryClick(category)"
                :key="category.code"
              >
                {{ category.name }}
                <i class="category-item__gap-icon" :key="category.code"></i>
              </li>
            </ul>
          </div>
          <div class="edit-btn" @click="onShare" v-if="isPC">
            <i class="edit-icon share-icon"></i>
            <p class="edit-text">{{ $t('分享') }}</p>
          </div>
          <fx-dropdown v-else @command="onShareClick" trigger="click">
            <div class="edit-btn">
              <i class="edit-icon share-icon"></i>
              <p class="edit-text">{{ $t('分享') }}</p>
            </div>
            <fx-dropdown-menu slot="dropdown">
              <fx-dropdown-item v-if="isFs" command="shareToConversation">{{ $t('分享到企信') }}</fx-dropdown-item>
              <fx-dropdown-item command="copyLink">{{ $t('复制链接') }}</fx-dropdown-item>
            </fx-dropdown-menu>
          </fx-dropdown>
          <div class="edit-btn" @click="onEdit" v-show="showEditBtn">
            <i class="edit-icon"></i>
            <p class="edit-text">{{ $t('编辑') }}</p>
          </div>
        </div>
        <div class="title">{{ article.title }}</div>
        <ul class="article-detail-msg">
          <li class="detail-msg-item" v-for="fieldData of article.extraShowFieldList" :key="fieldData.fieldApiName">
            {{
              fieldData.fieldLabel +
              '：' +
              ([undefined, null].includes(fieldData.fieldValue) ? '--' : fieldData.fieldValue)
            }}
          </li>
        </ul>
        <ul class="tag-list" v-if="article.tagInfoList">
          <li class="tag" :key="index" v-for="(tag, index) in article.tagInfoList">
            {{ tag.tagName }}
          </li>
        </ul>
        <div class="summary-area" v-if="article.summary">
          <span class="summary-title">{{ $t('摘要：') }}</span>
          <span class="summary-content">{{ article.summary || '--' }}</span>
        </div>
        <file-list
          class="preview-file"
          :class="{ 'one-file-only': isOneFileOnly }"
          v-if="article.materialMessage && article.materialMessage.length"
          :files="article.materialMessage"
          :knowledge-data="article"
        ></file-list>
        <template class="content">
          <template v-if="isOneFileOnly">
            <div
              ref="knowledgeIframeWrap"
              class="knowledge-iframe crm-scroll"
              :style="{ overflow: 'auto' }"
              :class="{ _hide: !iframeready }"
            >
              <iframe
                ref="knowledgeIframe"
                :key="article.materialMessage[0].preview_path"
                :src="article.materialMessage[0].preview_path"
                frameborder="0"
                class="detail-iframe"
                scrolling="no"
                width="100%"
                @load="setIntervalFn"
              >
              </iframe>
            </div>
          </template>
          <template v-else-if="article.contentType === 'text'">
            <div class="knowledge-text" v-html="article.text.replace(/(\n|\t)/g, '<br/>')"></div>
          </template>
          <template v-else-if="article.contentType === 'rich_text'">
            <div class="knowledge-iframe" :class="{ _hide: !iframeready }">
              <iframe
                ref="knowledgeIframe"
                :key="ready + article"
                frameborder="0"
                class="detail-iframe"
                :srcdoc="article.richText"
                scrolling="no"
                width="100%"
                @load="setIntervalFn"
              >
              </iframe>
            </div>
          </template>
        </template>
        <div class="detail-useful" v-if="!nofooter">
          <div
            class="detail-operate"
            @click="onClickUse"
            :class="{
              clicked: article.currentUserHelpful,
              disabled: article.currentUserNotHelpful && !article.currentUserHelpful,
            }"
          >
            <i class="useful-icon operate-icon"></i>
            <span>{{ +article.beHelpful }}</span>
          </div>
          <div
            class="detail-operate"
            @click="onClickUnuse"
            :class="{
              clicked: article.currentUserNotHelpful,
              disabled: article.currentUserHelpful && !article.currentUserNotHelpful,
            }"
          >
            <i class="unuseful-icon operate-icon"></i>
            <span>{{ +article.notHelpful }}</span>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <empty></empty>
    </template>
  </div>
</template>
<script>
import { device } from 'lib';
import FileList from '@/components/file_list/file_list';
import XSS from '@/util/xss';
import Empty from '@/components/empty';
import Api, { LoadConfig } from '@/service';
import WatermarkMixin from '@/common/mixin/watermark';
import BScroll from '@better-scroll/core';
import moment from 'moment/moment';
import util from '@/util';
import { Toast } from 'vant';
import ShareToQx from '@/components/share-to-qx/share-to-qx';
export default {
  mixins: [WatermarkMixin],
  data() {
    return {
      // vid: this.id || this.$route.query.id || '',
      noevent: (this.$route && this.$route.query.noevent) || 0,
      isPC: !device.isMobile,
      article: null,
      apiName: 'read_count',
      ready: 0,
      intervalId: null,
      iframeready: 0,
      iswx: device.wechatBrowser,
      // _loading: null,
      showPreviewImg: false,
      previewImgs: [],
      showEditBtn: false,
      isFs: device.fsBrowser,
    };
  },
  props: {
    id: {
      type: String,
      default() {
        const urlParams = util.getUrlParams();
        return (this.$route && this.$route.query.id) || urlParams.id || '';
      },
    },
  },
  components: {
    FileList,
    Empty,
  },
  watch: {
    ready(val) {
      if (!val) {
        return;
      }
      this.createWaterMark();
    },
    'article.title': function (title) {
      document.getElementsByTagName('title')[0].innerText = title;
    },
    isOneFileOnly: {
      handler(value) {
        if (!value) return;
        if (this.article.knowledgeAttachmentRecordStatus == 1) {
          const file = this.article.materialMessage[0];
          Api.increaseAttachmentRecordCount({
            fileId: file.path,
            knowledgeId: this.article.id,
            operator: 'preview',
          }).then(() => {
            file.preview_count++;
          });
        }
      },
      immediate: true,
    },
  },
  computed: {
    isOneFileOnly() {
      // const article = this.article || {};
      // return (
      //   article.materialMessage &&
      //   article.materialMessage.length === 1 &&
      //   article.materialMessage[0].preview_path &&
      //   (article.contentType !== 'text' || !article.text) &&
      //   (article.contentType !== 'rich_text' || !article.richText)
      // );
      return false;
    },
    ea() {
      const urlParams = util.getUrlParams();
      return (this.$route && this.$route.query.ea) || urlParams.ea || '';
    },
    noheader() {
      const urlParams = util.getUrlParams();
      const noheader = (this.$route && this.$route.query.esNoHeader) || urlParams.esNoHeader;
      return noheader == 1;
    },
    nofooter() {
      const urlParams = util.getUrlParams();
      const nofooter = (this.$route && this.$route.query.esNoFooter) || urlParams.esNoFooter;
      return nofooter == 1;
    },
    fsAppId() {
      const urlParams = util.getUrlParams();
      const routeQuery = (this.$route && this.$route.query) || {};
      const fsAppId = routeQuery.fsAppId || routeQuery.appId || urlParams.fsAppId || urlParams.appId;
      return fsAppId;
    },
  },
  methods: {
    onEdit() {
      window.open(
        `${location.origin}/XV/UI/Home?noheader=1&noMenu=1&dataId=${this.id}&closeAfterSubmitted=1#/app/knowledge/index/=/addknowledge`
      );
    },

    getArticleUrl() {
      return `${location.origin}/eservice/knowledge/share?fsEa=${this.ea}&id=${this.id}`;
    },

    async copyByClipboard(text) {
      try {
        await navigator.clipboard.writeText(text);
        Toast($t('已复制分享链接'));
      } catch (e) {
        console.error(e);
        Toast.fail($t('复制失败'));
      }
    },

    async copyByExecCommand(text) {
      try {
        const textArea = document.createElement('textArea');
        textArea.value = text;
        textArea.style.width = 0;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999px';
        textArea.style.top = '10px';
        textArea.setAttribute('readonly', 'readonly');
        document.body.appendChild(textArea);

        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);

        Toast($t('已复制分享链接'));
      } catch (e) {
        console.error(e);
        Toast.fail($t('复制失败'));
      }
    },

    async onShare() {
      const url = this.getArticleUrl();
      // if (!window.isPublic && this.isPC) {
      //   ShareToQx.$show({
      //     url,
      //     title: this.article.title || '--',
      //     summary: this.article.summary || '--',
      //   });
      //   return;
      // }
      const copyContent = this.article.title + ': ' + url;
      if (navigator.clipboard && navigator.permissions) {
        this.copyByClipboard(copyContent);
      } else {
        this.copyByExecCommand(copyContent);
      }
    },

    getValidDate(article) {
      if (!article.validityEndTime || !article.validityBeginTime) {
        return $t('永久有效');
      }
      return (
        moment(+article.validityBeginTime).format('YYYY-MM-DD') +
        $t('至') +
        moment(+article.validityEndTime).format('YYYY-MM-DD')
      );
    },
    getCreateTime(timesteamp) {
      return moment(+timesteamp).format('YYYY-MM-DD');
    },
    onCategoryClick(category) {
      const scene = localStorage.getItem(util.global.SCENARY_CACHE_NAME);
      const urlParams = util.getUrlParams();
      const isDownstream = !!urlParams.isEM6 && !!urlParams.fsAppId;
      // 下游
      if (this.isPC && !window.isPublic && isDownstream) {
        window.open(
          `${location.origin}/XV/Cross/Portal?fsAppId=${urlParams.fsAppId}&fs_out_appid=${urlParams.fsAppId}&appId=${
            urlParams.fsAppId
          }#/portal/thirdapp/=/portal-knowledge-page-list/params-${encodeURIComponent(
            JSON.stringify({
              categoryCode: category.code,
              // scenery: scene || this.article.scenaryList[0] || 'all',
              scenery: 'all',
            })
          )}`
        );
        return;
      }

      // pc端无身份
      if (this.isPC && window.isPublic) {
        this.$router.push({
          path: '/web-list',
          query: {
            categoryCode: category.code,
            // scenery: scene || this.article.scenaryList[0] || 'all',
            scenery: 'all',
          },
        });
        return;
      }

      // pc端有身份
      if (this.isPC && !window.isPublic) {
        window.open(
          `${location.origin}/XV/UI/Home?#/app/knowledge/index/=/knowledge-list-page/params-${encodeURIComponent(
            JSON.stringify({
              categoryCode: category.code,
              // scenery: scene || this.article.scenaryList[0] || 'all',
              scenery: 'all',
            })
          )}`
        );
        return;
      }

      // 默认情况
      this.$router.push({
        path: '/list',
        query: {
          code: category.code,
          // scenaryType: scene || this.article.scenaryList[0] || 'all',
          scenaryType: 'all',
        },
      });
    },
    getReadNum(readCount) {
      if (readCount > 10000) {
        return (readCount / 10000).toFixed(1) + 'w';
      } else if (readCount > 1000) {
        return (readCount / 1000).toFixed(1) + 'k';
      } else {
        return readCount;
      }
    },
    setIntervalFn() {
      this.setIframeHeight();
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.intervalId = setInterval(() => {
        this.setIframeHeight();
      }, 2000);
    },
    setIframeHeight() {
      const me = this;
      const $iframe = this.$refs.knowledgeIframe;
      if (!$iframe) return;

      const iframeWin = $iframe.contentWindow || $iframe.contentDocument.parentWindow;
      if (iframeWin.document.body) {
        const wrapHeight = this.$refs.knowledgeIframeWrap && this.$refs.knowledgeIframeWrap.offsetHeight;
        const height = iframeWin.document.documentElement.scrollHeight || iframeWin.document.body.scrollHeight;
        let width = iframeWin.document.documentElement.scrollWidth || iframeWin.document.body.scrollWidth;
        // console.log(height);
        if (width <= 375 || (me.isPC && width <= 750)) {
          width = '100%';
        }
        // console.log(me.iframeready);
        $iframe.height = wrapHeight > height ? wrapHeight : height;
        $iframe.width = width;
        me.iframeready = 1;
        me._loading && me._loading.hide();
        me._loading = null;

        // 附件预览样式
        const $fileIframeMain = iframeWin.document.getElementById('main');
        if ($fileIframeMain) {
          $fileIframeMain.style.overflow = 'auto';
        }
      }
    },
    updateLocalRecordHelpFul(data) {
      if (!window.isPublic) return;
      const helpfulRecord = JSON.parse(sessionStorage.getItem(this.id + '_helpfulRecord') || '{}');
      Object.assign(helpfulRecord, data);
      sessionStorage.setItem(this.id + '_helpfulRecord', JSON.stringify(helpfulRecord));
    },
    updateKnowledgeRecordCount({ type, config } = {}) {
      const me = this;
      if (this.noevent) {
        return;
      }
      const fnName = type === 'cancel' ? 'cancelKnowledgeRecordHelpful' : 'updateKnowledgeRecordCount';
      return Api[fnName](
        {
          apiName: me.apiName,
          id: this.id,
        },
        config
      );
    },
    onClickUse() {
      if (!this.article.currentUserHelpful && this.article.currentUserNotHelpful) return;
      // const me = this;
      if (this.noevent) {
        return;
      }
      let type = '';
      if (this.article.currentUserHelpful) {
        type = 'cancel';
      }
      this.apiName = 'be_helpful';

      const queryConfig = new LoadConfig({
        needSuccess: true,
        successMsg: $t('有帮助'),
      });

      this.updateKnowledgeRecordCount({ type, config: queryConfig })
        .then(() => {
          this.article.beHelpful += type === 'cancel' ? -1 : 1;

          this.updateLocalRecordHelpFul({
            currentUserHelpful: type !== 'cancel',
          });
        })
        .always(this.queryKnowledgeRecordDetail);
    },
    onClickUnuse() {
      if (!this.article.currentUserNotHelpful && this.article.currentUserHelpful) return;
      if (this.noevent) {
        return;
      }
      let type = '';
      if (this.article.currentUserNotHelpful) {
        type = 'cancel';
      }
      this.apiName = 'not_helpful';

      const queryConfig = new LoadConfig({
        needSuccess: true,
        successMsg: $t('没有帮助'),
      });

      this.updateKnowledgeRecordCount({ type, config: queryConfig })
        .then(() => {
          this.article.notHelpful += type === 'cancel' ? -1 : 1;

          this.updateLocalRecordHelpFul({
            currentUserNotHelpful: type !== 'cancel',
          });
        })
        .always(this.queryKnowledgeRecordDetail);
    },
    // 兼容多个富文本字段
    getRichText(dt) {
      let rt = '';
      const _rep = txt => {
        return txt.replace(
          /width:595.0pt;margin-bottom:72.0pt;margin-top:72.0pt;margin-left:90.0pt;margin-right:90.0pt;/g,
          ''
        );
      };
      // 仅对富文本处理
      if (dt.contentType !== 'rich_text') {
        return dt;
      }
      if (dt.richText) {
        rt = dt.richText;
      }

      if (dt.richTextTwo) {
        rt += dt.richTextTwo;
      }

      if (dt.richTextThree) {
        rt += dt.richTextThree;
      }
      dt.richText = XSS(_rep(rt));
      return dt;
    },
    queryKnowledgeRecordDetail() {
      const me = this;
      return Api.queryKnowledgeRecordDetail({
        id: this.id,
      })
        .then(res => {
          me.ready++;
          if (res.errCode === 'C120040000') {
            if (window.isPublic) {
              const helpfulRecord = JSON.parse(sessionStorage.getItem(this.id + '_helpfulRecord') || '{}');
              Object.assign(res.data, {
                currentUserHelpful: helpfulRecord.currentUserHelpful,
                currentUserNotHelpful: helpfulRecord.currentUserNotHelpful,
              });
            }

            me.showEditBtn = res.data.showEditButton && this.isPC && !window.isPublic && !this.fsAppId;
            const _dt = me.getRichText(res.data);
            me.$set(me, 'article', _dt);
            if (['rich_text', 'html_rich_text'].includes(this.article.contentType)) {
              // me._loading = util.loading('加载中...');
              // me.article.richText = me.article.richText.replace('width:595.0pt;margin-bottom:72.0pt;margin-top:72.0pt;margin-left:90.0pt;margin-right:90.0pt;', '');
              // console.log(me.article.richText);
              if (me.iswx) {
                // hack ios微信iframe有点问题，这里针对微信做特殊处理
                me.$nextTick(() => {
                  const $iframe = me.$refs.knowledgeIframe;
                  if (!$iframe) return;
                  // fixed article.richText 为空时，无法显示附件
                  if (!me.article.richText) {
                    me.article.richText = '&nbsp;';
                  }
                  $iframe.contentWindow.document.write(me.article.richText);
                  const link = $iframe.contentWindow.document.createElement('link');
                  // todo not finish 写死的hash 以后还会有问题
                  link.href =
                    'https://a9.fspage.com/FSR/frontend/html/app-dist/common-dist/assets/style/preview-f9b0e96dbf.css';
                  link.rel = 'stylesheet';

                  const style = $iframe.contentWindow.document.createElement('style');
                  style.innerHTML = 'img {max-width: 100% !important; height: unset !important;}';
                  style.type = 'text/css';

                  const $head = $iframe.contentWindow.document && $iframe.contentWindow.document.head;
                  // 企业微信中 $head 为null, 报错
                  if ($head) {
                    $head.appendChild(link);
                    $head.appendChild(style);
                  }
                  // $iframe.contentWindow.document.head.appendChild(link);
                  me.setIntervalFn();
                });
              }
              me.getIframeDoc(iframe => {
                me.addIframeCss(iframe);
                me.addIframeEvent(iframe);
              });
            }
          } else {
            me.showError(res);
            return Promise.reject();
          }
        })
        .then(() => {
          this.updateDom();
        })
        .catch(() => {
          // loading.hide();
          return Promise.reject();
        });
    },
    // 在iframe有head的时候获取iframe
    getIframeDoc(fn) {
      if (this.__addIframeCssCounter) {
        this.__addIframeCssCounter++;
      } else {
        this.__addIframeCssCounter = 1;
      }
      if (this.__addIframeCssCounter >= 500) {
        this.__addIframeCssCounter = 0;
        return;
      }
      const $iframe = this.$refs.knowledgeIframe;
      const head = $iframe && $iframe.contentWindow.document.head;
      // 未加载完成时head为null
      if (!head) {
        setTimeout(() => {
          this.getIframeDoc(fn);
        }, 200);
        return;
      }
      fn($iframe);
    },
    addIframeCss(iframe) {
      const doc = iframe.contentWindow.document;
      const link = doc.createElement('link');
      // todo not finish 写死的hash 以后还会有问题
      link.href = 'https://a9.fspage.com/FSR/frontend/html/app-dist/common-dist/assets/style/preview-f9b0e96dbf.css';
      link.rel = 'stylesheet';

      const style = doc.createElement('style');
      style.innerHTML = `
        span, p {
          white-space: pre-wrap; /* 保留文章的缩进、空格 */
        }
        img {
          max-width: 100%;
        }
        *[style*="white-space: pre"] {
          white-space: pre-wrap !important;
        }
      `;
      style.type = 'text/css';

      doc.head.appendChild(link);
      doc.head.appendChild(style);
    },
    addIframeEvent(iframe) {
      const me = this;
      const imgPreview = el => {
        me.$imagePreview({
          images: [el.target.src],
          closeable: true,
        });
      };
      const imgClickHandler = el => {
        if (el.target.tagName.toLowerCase() !== 'img') {
          return;
        }
        imgPreview(el);
      };
      const linkClickHandler = e => {
        if (e && e.target && e.target.tagName.toLowerCase() === 'a' && e.target.target === '_self') {
          window.open(e.target.href);
        }
      };
      iframe.contentWindow.addEventListener('click', imgClickHandler);
      iframe.contentWindow.addEventListener('click', linkClickHandler);
    },
    updateDom() {
      setTimeout(() => {
        this.categoryListScroll = new BScroll(this.$refs.categoryListWrap, {
          scrollX: true,
          click: true,
        });
      }, 200);
    },

    onShareClick(command) {
      if (command === 'shareToConversation') {
        const { title } = this.article;
        const link = this.getArticleUrl();
        window.jsApi.fs.service.share.toConversation({
          title: $t('知识分享'),
          desc: title,
          link,
          imgUrl: 'https://www.fxiaoke.com/static/img/index/logo.png?v=5.1.5',
        });
      } else {
        this.onShare();
      }
    },
  },
  mounted() {
    this.queryKnowledgeRecordDetail().then(this.updateKnowledgeRecordCount);
  },
  created() {
    // if (!window.isPublic && this.isPC) {
    //   ShareToQx.preLoad();
    // }
    // FS.jsapi.setWebViewTitle({ title: '知识库' });
  },
  destroyed() {
    this.$emit('close');
  },
};
</script>
<style lang="less">
.auto-grow {
  body {
    .public-knowledge {
      min-height: 100%;
      height: auto !important;
      overflow: unset;
      .knowledgelib-detail {
        height: auto;
      }
    }
  }
}
</style>
<style lang="less" scoped>
.pc {
  .knowledgelib-detail {
    .knowledgelib-detail-wrap {
      padding: 23px 82px 30px;
    }
  }
}
.knowledgelib-detail {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #fff;
  .knowledgelib-detail-wrap {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 12px;
    overflow: auto;
    flex: 1;
    // flex-direction: column;
    -webkit-overflow-scrolling: touch;
  }
  .loadmore-empty {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    // justify-content: center;
    &-icon {
      width: 100%;
      height: 110px;
      background: url(../../assets/images/empty.png) no-repeat center;
      background-size: auto 100%;
      margin-top: 120px;
    }
    &-tip {
      margin-top: 40px;
      font-size: 28px !important;
      color: #bdbdbd;
    }
  }

  .top-area {
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    .edit-btn {
      flex: 0 0 auto;
      margin-left: 10px;
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #91959e;
      cursor: pointer;
      white-space: nowrap;
      .edit-icon {
        margin-right: 4px;
        width: 12px;
        height: 12px;
        background-repeat: no-repeat;
        background-position: center;
        background-image: url('../../assets/images/edit-icon.svg');
      }
      .share-icon {
        background-image: url('../../assets/images/share-icon.svg');
      }
    }
  }
  .category-list-wrap {
    display: flex;
    width: 100%;
    overflow: hidden;
  }
  .category-list {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    width: auto;
    .category-item {
      display: inline-flex;
      align-items: center;
      color: #0c6cff;
      white-space: nowrap;
      font-size: 14px;
      cursor: pointer;
      .category-item__gap-icon {
        flex: 0 0 14px;
        margin: 0 4px;
        width: 14px;
        height: 14px;
        background-repeat: no-repeat;
        background-position: center;
        background-image: url('~@/assets/images/arrow-right.svg');
      }

      &:last-child {
        .category-item__gap-icon {
          display: none;
        }
      }
    }
  }
  .title {
    margin-bottom: 10px;
    line-height: 30px;
    color: #000000;
    font-weight: 700;
    font-size: 24px;
    text-align: left;
  }
  .article-detail-msg {
    margin-bottom: 12px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    font-size: 12px;
    color: #91959e;
    .detail-msg-item {
      margin: 3px 10px 0 0;
      padding-right: 10px;
      line-height: 12px;
      &:not(:last-child) {
        border-right: 1px solid #91959e;
      }
    }
  }
  .tag-list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 10px;

    .tag {
      box-sizing: border-box;
      margin: 0 8px 8px 0;
      padding: 0px 5px;
      height: 20px;
      line-height: 20px;
      max-width: 100%;
      font-size: 12px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      color: #181c25;
      background: #f2f4fb;
      border-radius: 2px;
    }
  }
  .summary-area {
    margin-bottom: 18px;
    padding: 12px 14px;
    border-radius: 4px;
    font-size: 14px;
    color: #545861;
    background: #f2f4fb;
    .summary-title {
      font-weight: bold;
    }
  }
  /deep/ .preview-file.one-file-only {
    margin-bottom: 0;
  }
  .knowledge-text {
    flex: 1;
    // padding: 0 20px;
    word-wrap: break-word;
    word-break: break-all;
  }
  .knowledge-iframe {
    flex: 1;
    // -webkit-overflow-scrolling: touch;
    // width: 100%;
    // padding: 0px 20px;
    background-color: #fff;
    // box-sizing: border-box;
    // height: 100%;
    &._hide {
      visibility: hidden;
    }
    .detail-iframe {
      max-width: 100%;
    }
    img {
      max-width: 100%;
    }
  }
  .detail-useful {
    margin-top: 15px;
    background-color: #fff;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .detail-operate {
      padding: 10px 14px;
      display: flex;
      align-items: center;
      color: #737c8c;
      border-radius: 18px;
      border: 1px solid #737c8c;
      cursor: pointer;
      &:not(:last-child) {
        margin-right: 13px;
      }
      &.clicked {
        color: #ff8000;
        border-color: #ff8000;
        .useful-icon {
          background-image: url(../../assets/images/like-active.svg);
        }
        .unuseful-icon {
          background-image: url(../../assets/images/dislike-active.svg);
        }
      }
      &.disabled {
        cursor: no-drop;
      }
    }
    .operate-icon {
      display: block;
      margin-right: 4px;
      width: 16px;
      height: 16px;
      background-repeat: no-repeat;
      background-position: center;
      &.useful-icon {
        background-image: url(../../assets/images/like.svg);
      }
      &.unuseful-icon {
        background-image: url(../../assets/images/dislike.svg);
      }
    }
  }
}
.knowledge-detail-use {
  .weui-loading {
    background: url(../../assets/images/useful.png) no-repeat;
    background-size: contain;
    width: 30px;
    height: 30px;
    animation: none;
  }
}
.knowledge-detail-nouse {
  .weui-loading {
    background: url(../../assets/images/unuseful.png) no-repeat;
    background-size: contain;
    width: 30px;
    height: 30px;
    animation: none;
  }
}

.knowledgelib-detail__share-btn {
  display: flex;
  align-items: center;
}
</style>
